/**
 * Shown when the application's boot gates never finish.
 *
 * ⚠️ THIS EXISTS BECAUSE THE ALTERNATIVE WAS AN INFINITE SPINNER. Measured 2026-08-16: with
 * the Supabase auth lock held, the app sat on "Loading..." past 60 seconds with no way out
 * but a manual tab reload — and a user has no way to know that a reload is what is needed.
 * Reloading is exactly what people were already doing by trial and error, so this offers it.
 *
 * ⚠️ A RELOAD, NOT A RETRY OF THE FETCHES. By the time this renders, the failure is not one
 * request: the auth, tenant and permission contexts are each holding state built from a boot
 * that did not complete, and a permission fetch that was aborted mid-flight will not restart
 * itself. Re-running one of them leaves the other two stale. A fresh document is the only
 * recovery that is honest about how much has to be rebuilt.
 */
export function WorkspaceUnavailable() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-xl font-semibold text-foreground">
          We couldn&apos;t finish loading your workspace
        </h1>
        <p className="text-sm text-muted-foreground">
          Your session is still valid — something took too long to load. Reloading usually
          clears it. If it keeps happening, let support know.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          Reload
        </button>
      </div>
    </div>
  );
}
